// Mirror of chave-cmb-api manufacturer DTOs. Keep in sync with
// src/modules/manufacturers/dto/IManufacturerStockDTO.ts on the API.

export type StockStatus = 'pending' | 'activated' | 'revoked';

export interface ManufacturerStock {
  id: number;
  manufacturer_id: number;
  manufacturer_name?: string;
  bluetooth: string;
  cmb_number: number;
  firmware_protocol: string;
  intended_company_id: number | null;
  intended_company_name: string | null;
  notes: string | null;
  status: StockStatus;
  jti: string;
  token_revoked: boolean;
  activated_at: string | null;
  activated_by_user_id: number | null;
  activated_by_user_name: string | null;
  activated_to_company_id: number | null;
  activated_to_company_name: string | null;
  activated_to_box_id: number | null;
  created_by_user_id: number;
  created_at: string;
  updated_at: string;
}

export interface StockListResponse {
  rows: ManufacturerStock[];
  total: number;
}

export interface StockCreateResponse {
  stock: ManufacturerStock;
  token: string;       // JWT to program into firmware
}

export interface StockTokenResponse {
  token: string;
  jti: string;
}

export interface CsvImportResponse {
  created: Array<{
    id: number;
    bluetooth: string;
    cmb_number: number;
    token: string;
  }>;
  errors: Array<{ line: number; reason: string }>;
}

export interface BatchActivateResponse {
  activated: Array<{ stock_id: number; box_id: number; company_id: number }>;
  errors: Array<{ stock_id: number; reason: string }>;
}

export const STOCK_STATUS_LABEL: Record<StockStatus, string> = {
  pending: 'Aguardando ativação',
  activated: 'Ativada',
  revoked: 'Revogada',
};
